import DashboardLayout from 'examples/LayoutContainers/DashboardLayout'
import DashboardNavbar from 'examples/Navbars/DashboardNavbar'

export default function Home() {
    return (
        <DashboardLayout>
            <DashboardNavbar />
        </DashboardLayout>
    )
}
